import {
  Component,
  Inject,
  OnInit
} from '@angular/core';

import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';

import { DatePipe } from '@angular/common';

import * as XLSX from 'xlsx';

@Component({
  selector:
    'app-book-seller-posting-label-brief',

  templateUrl:
    './book-seller-posting-label-brief.component.html',

  styleUrls:
    ['./book-seller-posting-label-brief.component.scss']
})

export class BookSellerPostingLabelBriefComponent
implements OnInit {

  labelsData: any[] = [];

  flatData: any[] = [];

  currentDate: Date = new Date();

  country = '';
  state = '';
  district = '';
  taluka = '';

  rep_name = '';
  office_rep_name = '';

  delivery_mode = '';

  sub_type = '';

  constructor(

    private datePipe: DatePipe,

    private dialogRef:
      MatDialogRef<BookSellerPostingLabelBriefComponent>,

    @Inject(MAT_DIALOG_DATA)
    public data: any

  ) {}

  // =====================================================
  // INIT
  // =====================================================

  ngOnInit(): void {
    debugger

    this.labelsData =
      this.data?.addresslabels || [];

    this.country =
      this.data?.country || '';

    this.state =
      this.data?.state_name || '';

    this.district =
      this.data?.district_name || '';

    this.taluka =
      this.data?.taluka_name || '';

    this.rep_name =
      this.data?.rep_name || '';

    this.office_rep_name =
      this.data?.office_rep_name || '';

    this.delivery_mode=
      this.data?.delivery_mode || '';

    this.sub_type =
      this.data?.sub_type || '';

    // SORT BY PINCODE

    this.labelsData.sort(
      (a: any, b: any) =>
        Number(a?.pincode || 0) -
        Number(b?.pincode || 0)
    );

    // FLAT DATA

    this.flatData = [...this.labelsData];

    console.log(
      'Flat Data => ',
      this.flatData
    );
  }

  // =====================================================
  // FORMAT ADDRESS
  // =====================================================

  getFullAddress(item: any): string {

    return `
      ${item?.address || ''}
      ${item?.taluka || ''}
      ${item?.district || ''}
      ${item?.state || ''}
      ${item?.country || ''}
      ${item?.pincode || ''}
    `.replace(/\s+/g, ' ').trim();
  }

  // =====================================================
  // PRINT
  // =====================================================

printPage4() {
       // this.show = true;
       const printSection = document.getElementById('print-section');
       if (!printSection) {
         console.error("Print section not found!");
         return;
       }
   
       const printContent = printSection.innerHTML;
   
       const screenWidth = window.screen.availWidth;
       const windowWidth = 1400;
       const leftPosition = screenWidth - windowWidth - 50;
   
       const printWindow = window.open('', '', `width=${windowWidth},height=1000,top=50,left=${leftPosition},scrollbars=yes`);
   
       if (printWindow) {
         printWindow.document.open();
         printWindow.document.write(`
             <html>
                 <head>
                     <title>Print Report</title>
                     <style>
                         @media print {
                             @page {
                                 size: A4 landscape;
                                 margin: 3mm;
                             }
                             .report-container {
     background: rgb(15, 15, 15);
     border-radius: 12px;
     box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
     overflow: hidden;
     margin: 20px auto;
 }
 
 .report-header {
     background: #f8f9fa;
     color: #333333;
     padding: 20px;
     text-align: center;
 }
 
 .report-title {
     font-size: 18px;
     font-weight: bold;
     margin-bottom: 10px;
 }
 
 .report-subtitle {
     font-size: 14px;
     opacity: 0.9;
 }
 
 .table-responsive {
     overflow-x: auto;
     background: white;
 }
 
 .styled-table {
     width: 100%;
     border-collapse: collapse;
     font-size: 13px;
     font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
 }
 
 .styled-table thead {
     background: #e9ecef;
     color: #495057;
 }
 
 .styled-table thead th {
     padding: 15px 10px;
     text-align: center;
     font-weight: 600;
     border: 1px solid #dee2e6;
     text-shadow: none;
 }
 
 .styled-table tbody td {
     padding: 8px 10px;
     border: 1px solid #e2e8f0;
     vertical-align: middle;
     color: #000000;
 }
 
 .styled-table tbody tr:nth-child(even) {
     background-color: #f8fafc;
 }
 
 .styled-table tbody tr:hover {
     background-color: #e2e8f0;
     transition: background-color 0.2s ease;
 }
 
 .office-header {
     background: #d1ecf1 !important;
     color: #0c5460 !important;
     font-weight: bold !important;
     font-size: 14px !important;
 }
 
 .rep-header {
     background: #d4edda !important;
     color: #155724 !important;
     font-weight: bold !important;
     font-size: 14px !important;
 }
 
 .rep-total {
     background: #fff3cd !important;
     color: #856404 !important;
     font-weight: bold !important;
     font-size: 13px !important;
 }
 
 .office-total {
     background: #f8d7da !important;
     color: #721c24 !important;
     font-weight: bold !important;
     font-size: 14px !important;
 }
 
 .styled-table tfoot {
     background: #e9ecef;
     color: #495057;
 }
 
 .styled-table tfoot td {
     padding: 15px 10px;
     font-weight: bold;
     font-size: 16px;
     border: 1px solid #dee2e6;
 }
 
 .data-row td {
     font-size: 12px !important;
     font-weight: 500 !important;
     color: #000000 !important;
 }
 
 .amount-cell {
     font-family: 'Courier New', monospace !important;
     background: #f7fafc !important;
     color: #000000 !important;
 }
 
 .button-container {
     background: white;
     padding: 20px;
     display: flex;
     justify-content: flex-end;
     gap: 10px;
     border-top: 1px solid #e2e8f0;
 }
 
 .modern-btn {
     padding: 10px 20px;
     border: none;
     border-radius: 6px;
     cursor: pointer;
     font-weight: 600;
     text-transform: uppercase;
     letter-spacing: 0.5px;
     transition: all 0.3s ease;
     font-size: 12px;
 }
 
 .btn-primary-modern {
     background: #6c757d;
     color: white;
     box-shadow: 0 4px 15px rgba(108, 117, 125, 0.4);
 }
 
 .btn-primary-modern:hover {
     transform: translateY(-2px);
     box-shadow: 0 6px 20px rgba(108, 117, 125, 0.6);
 }
 
 .btn-secondary-modern {
     background: #e2e8f0;
     color: #4a5568;
     border: 1px solid #cbd5e0;
 }
 
 .btn-secondary-modern:hover {
     background: #cbd5e0;
     transform: translateY(-1px);
 }    
                             body {
                                 font-family: Arial, sans-serif;
                                 margin: 0;
                                 padding: 0;
                                 font-size: 10px !important;
                             }
                             .print-section {
                                 width: 100%;
                                 margin: 0 auto;
                                 padding: 0;
                             }
                             table {
                                 width: 100% !important;
                                 border-collapse: collapse;
                                 table-layout: auto;
                                 page-break-inside: auto;
                             }
                             tr {
                                 page-break-inside: avoid;
                                 page-break-after: auto;
                             }
                             th, td {
                                 padding: 3px 5px !important;
                                 border: 1px solid black !important;
                                 font-size: 10px;
                                 line-height: 1.3;
                                 word-wrap: break-word;
                                 overflow-wrap: break-word;
                             }
                             th {
                                 background-color: #f2f2f2;
                             }
                             tr {
                                 border-bottom: 1px solid black !important;
                             }
                             tr.header-row {
                                 display: table-header-group;
                             }
                             td:nth-child(1) {
                                 width: 1%;
                                 text-align: left !important;
                             }
                             td:nth-child(2),
                             td:nth-child(3),
                             td:nth-child(4),
                             td:nth-child(5),
                             td:nth-child(6),
                             td:nth-child(8) {
                                 text-align: left !important;
                             }
                             td:nth-child(5) {
                                 width: 5%;
                                 white-space: normal;
                             }
                             td.advt-name {
                                 max-width: 160px;
                                 white-space: nowrap;
                                 overflow: hidden;
                                 text-overflow: ellipsis;
                             }
                             td:nth-child(n+12),
                             td.amount,
                             td[data-type="number"] {
                                 text-align: right !important;
                             }
                             td.text,
                             td[data-type="string"] {
                                 text-align: left !important;
                             }
                             .br-right { border-right: 1px solid black !important; }
                             .br-rightt { border-right: 4px solid black !important; }
                             .br-bottom { border-bottom: 2px solid black !important; }
                             .br-top { border-top: 2px solid black !important; }
                             .noPrint { display: none !important; }
                             .footer-line {
                                 position: fixed;
                                 bottom: 0;
                                 left: 0;
                                 width: 100%;
                                 height: 2px;
                                 background-color: black;
                             }
                             thead { display: table-header-group; }
                             tfoot { display: table-footer-group; }
                             td.balance-value {
                                 text-align: right !important;
                             }
                         }
                     </style>
                 </head>
                 <body>
                     <div class="print-section">
                         ${printContent}
                         <div class="footer-line"></div>
                     </div>
                     <script>
                        window.onload = function () {
       const table = document.querySelector('table');
       if (!table) {
           console.error("Table not found");
           return;
       }
   
       let headerRowIndex = -1;
       const maxRowsToCheck = Math.min(10, table.rows.length);
   
       // Find header row with column names
       for (let i = 0; i < maxRowsToCheck; i++) {
           const row = table.rows[i];
           const cellTexts = Array.from(row.cells).map(cell => cell.textContent.trim());
   
           if (row.cells.length >= 8 &&
               (cellTexts.includes('Invoice No') ||
                cellTexts.includes('Receipt No') ||
                cellTexts.includes('Balance'))) {
               headerRowIndex = i;
               break;
           }
       }
   
       if (headerRowIndex >= 0) {
           // Create thead and move only the actual header row into it
           let thead = table.querySelector('thead');
           if (!thead) {
               thead = document.createElement('thead');
               table.insertBefore(thead, table.firstChild);
           }
   
           const headerRow = table.rows[headerRowIndex];
           thead.appendChild(headerRow); // move actual header row
   
           // Leave the other rows (like titles) in tbody so they don’t repeat
       }
   
       // Alignment processing (no change needed here)
       const cells = document.querySelectorAll('td');
       cells.forEach(cell => {
           const content = cell.textContent.trim();
   
           if (content.includes('येणे') ||
               content.includes('Opening Balance') ||
               content.match(/^\d+\s+येणे$/) ||
               content.includes('Balance C/F') ||
               content.includes('Total')) {
               cell.style.textAlign = 'right';
               cell.classList.add('balance-value');
           }
   
           const numericPattern = /^-?\\d+(,\\d{3})*(\\.\\d+)?$/;
           if (numericPattern.test(content.replace(/[\\s,]/g, ''))) {
               cell.style.textAlign = 'right';
               cell.classList.add('amount');
           }
       });
   
       setTimeout(() => {
           window.print();
           setTimeout(() => { window.close(); }, 500);
       }, 200);
   };
   
                     </script>
                 </body>
             </html>
         `);
         printWindow.document.close();
       } else {
         console.error("Failed to open print window.");
       }
     }

  // =====================================================
  // EXPORT EXCEL
  // =====================================================

 excelToExportPostingLabel(fileName: string): void {

  const exportData = this.flatData.map((row: any, index: number) => ({

    'Sr No': index + 1,

    'Month/Booking No': `${row?.month || ''}/${row?.subno || ''}`,

    'Booking Date': this.datePipe.transform(row?.booking_date, 'dd/MM/yyyy'),

    'Name': row?.name || '',

    'Address': this.getFullAddress(row),

    // ✅ FIXED HERE
    'Mobile': row?.mobile_no || '',

    'Copies': row?.book_copies || 0

  }));

  const worksheet = XLSX.utils.json_to_sheet(exportData);

  const workbook = {
    Sheets: { Report: worksheet },
    SheetNames: ['Report']
  };

  const excelBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array'
  });

  const blob = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });

  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${fileName}.xlsx`;
  link.click();

  URL.revokeObjectURL(link.href);
}
get uniqueBookNames(): string {
  return [...new Set(this.flatData.map(item => item.book_names))].join(', ');
}
get totalBookCopies(): number {
    return this.flatData.reduce((sum, item) => sum + (Number(item.book_copies) || 0), 0);
  }


}